import { NEW_SESSION_FROM } from './types'

type SessionState = {
  sessionId: string
  sequenceNum: number
  lastEmitTimestamp: number
  fromPage: string
}

let state: SessionState = {
  sessionId: '',
  sequenceNum: 0,
  lastEmitTimestamp: 0,
  fromPage: NEW_SESSION_FROM,
}

export const getSessionState = () => state

export const setSessionState = (partial: Partial<SessionState>) => {
  state = { ...state, ...partial }
}

/** Atomically increment and return the new sequence number. Use the return value. */
export const incrementSequence = () => {
  state = { ...state, sequenceNum: state.sequenceNum + 1 }
  return state.sequenceNum
}

/** Start a fresh funnel session. Callable from any context (not React-coupled). */
export const resetSession = () => {
  state = {
    sessionId: crypto.randomUUID(),
    sequenceNum: 0,
    lastEmitTimestamp: 0,
    fromPage: NEW_SESSION_FROM,
  }
}

/** Initialize on mount. Returns true if a new session was created. */
export const initSession = (): boolean => {
  if (state.sessionId) return false
  resetSession()
  return true
}
